import React from "react";
// UI Framework
import { toast } from "react-toastify";
// Common Components
import { Button, DynamicDropdown, TextInput } from "src/Components";
// Requests
import {
  addPortfoGroupLimitItem,
  getInstrumentsDropDown,
} from "src/Requests/portfolioGroups";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import { IAddLimitItemParams } from "src/Interfaces/portfolioGroups";

interface IProps {
  onSuccess: () => void;
  portfolioGroupId?: number;
  assetType?: number;
}

const AddLimitItemModal: React.FC<IProps> = ({
  onSuccess,
  portfolioGroupId,
  assetType,
}) => {
  const [loading, setLoading] = React.useState(false);
  const hasAssetLimit = Boolean(portfolioGroupId && assetType);
  const [formValues, setFormValues] = React.useState<IAddLimitItemParams>({
    portfolioGroupId,
    assetType,
  } as IAddLimitItemParams);

  const onChange = (name: string, value: string | number) => {
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const submitHandler = () => {
    setLoading(true);
    addPortfoGroupLimitItem({
      ...formValues,
      minValue: Number(formValues.minValue) || 0,
    })
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          onSuccess();
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-col justify-start items-start gap-4 min-w-[360px] p-2">
      {hasAssetLimit ? (
      <DynamicDropdown
        inputId={assetType}
        dropdown={{
          name: "isin",
          placeholder: "نماد",
          extraLabel: true,
        }}
        getData={() => getInstrumentsDropDown(assetType)}
        onChange={onChange}
        value={formValues?.isin ?? ""}
      />
      ) : null}
      <TextInput
        name="minValue"
        label="٪ کف"
        extraLabel
        onChange={onChange}
        value={formValues?.minValue?.toString() ?? ""}
      />
      <TextInput
        name="maxValue"
        label="٪ سقف"
        extraLabel
        onChange={onChange}
        value={formValues?.maxValue?.toString() ?? ""}
      />
      <Button
        text="افزودن"
        onClick={submitHandler}
        variant="contained"
        loading={loading}
        disabled={!hasAssetLimit || !formValues.isin}
      />
    </div>
  );
};

export default AddLimitItemModal;
